module.exports = __webpack_public_path__ + "static/img/1_3_1.2a78e7c5.jpg";